/** Severity for library logging. */
export enum LogType {
  Debug = 0,
  Warning = 1,
  Error = 2,
}
